module.exports = __webpack_public_path__ + "img/sv.1176ea28.svg";